import { AuthDynamoDB } from '@/provider/dynamodb'
import AwsExports from '@/assets/aws-exports'

export class DivisionMasterModel {
  /** 分割ID */
  id: string = ''
  /** 表示名 */
  displayName: string = ''
  /**
   * データ作成日時
   * ISO8601(UTC)
   */
  createdAt: Date = new Date()
  /**
   * データ更新日時
   * ISO8601(UTC)
   */
  updatedAt: Date = new Date()
}

export default class DivisionMasterProvider {
  private readonly TABLE_NAME: string = AwsExports.resourceNamePrefix + '-DivisionMaster'
  db: AuthDynamoDB

  constructor () {
    this.db = new AuthDynamoDB()
  }

  /**
   * 分割マスターの全件取得
   */
  async load () {
    const params = {
      TableName: this.TABLE_NAME
    }
    const result = await this.db.scan(params)
    if (!result.Items) {
      throw Error('Cannot load DivisionMaster')
    }
    console.debug('DivisionMaster is loaded.')
    const items = result.Items as DivisionMasterModel[]
    items.sort((a, b) => {
      if (a.id > b.id) return 1
      if (a.id < b.id) return -1
      return 0
    })
    return items
  }
}
